// extracted by mini-css-extract-plugin
export default {"a":"style_a__+c8hL","img":"style_img__6D7RW","container":"style_container__xPTC0","title":"style_title__ZMBQW","email":"style_email__VTXR-","icon":"style_icon__RXEUR"};